import React, { useEffect } from "react";
import Select from "react-select";
import { Controller } from "react-hook-form";
import { useSalidaForm } from "../hooks/useSalidaForm";
import LoadMask from "Utils/LoadMask/LoadMask";
import { DetallesSalidaList } from "./DetallesSalidaList";
import { DetallesSalidaSobranteList } from "./DetallesSalidaSobranteList";
import { AvisoPalletsIngresadosDespues } from "../../../../components/AvisoPalletsIngresadosDespues";
import {
    opciones_salida_bodega_pt,
    opciones_destino_bodega_pt,
} from "../../../../../../../../utility/constants";
import { DecisionSwal } from "../../../../../../Utils/Utils/DecisionSwal";

export const SalidaForm = ({ regresar, navigateToBoleta, nombreUsuario }) => {
    const {
        formControl,
        formRegister,
        formErrors,
        formWatch,
        formGetValues,
        formSetValue,

        detallesSalida,
        setDetallesSalida,
        detallesSobrante,
        setDetallesSobrante,
        almacenesReprocesoDisponibles,
        palletsOcultos,
        fechaHoraBodega,
        FormSubmit,
        cargando,
    } = useSalidaForm(navigateToBoleta);

    const tipoSalidaSeleccionada = formWatch("tipo_salida");
    const tipoDestinoSeleccionado = formWatch("tipo_destino");

    const opcionesDestinoFiltradas = opciones_destino_bodega_pt.filter(
        (opcion) => {
            return (
                tipoSalidaSeleccionada &&
                opcion.tipo === tipoSalidaSeleccionada.value
            );
        },
    );

    const MostrarMensajeCambiarTipoSalida = (onConfirmar) => {
        let mensaje = "Ya has agregado productos a esta salida. ";
        mensaje +=
            "Si cambias el tipo de salida se eliminarán todos los productos agregados ";
        mensaje +=
            "y también se limpiará el tipo de destino. ¿Deseas continuar?";

        DecisionSwal(mensaje, "Sí, cambiar", "Cancelar", onConfirmar);
    };

    const MostrarMensajeCambiarTipoDestino = (onConfirmar) => {
        let mensaje = "Ya has agregado productos con este destino. ";
        mensaje +=
            "Si cambias el destino se eliminarán todos los productos agregados, ";
        mensaje +=
            "ya que datos como la tarjeta amarilla o el almacén de reproceso ";
        mensaje += "no aplican para el nuevo destino. ¿Deseas continuar?";

        DecisionSwal(mensaje, "Sí, cambiar", "Cancelar", onConfirmar);
    };

    return (
        <LoadMask loading={cargando} blur>
            <div className="formulario-fields-row">
                <div className="formulario-field" style={{ minWidth: "100px" }}>
                    <label className="text-nowrap">Tipo de salida</label>
                    <Controller
                        name="tipo_salida"
                        control={formControl}
                        rules={{
                            required: "Este campo es obligatorio",
                        }}
                        render={({ field }) => (
                            <Select
                                {...field}
                                className="react-select-container"
                                backspaceRemovesValue={false}
                                isSearchable
                                options={opciones_salida_bodega_pt}
                                placeholder="Seleccionar"
                                onChange={(selectedOption) => {
                                    const tipoActual = field.value;

                                    // Si realmente no cambió, no hacer nada
                                    if (
                                        (tipoActual && tipoActual.value) ===
                                        (selectedOption && selectedOption.value)
                                    ) {
                                        return;
                                    }

                                    const aplicarCambio = () => {
                                        field.onChange(selectedOption);
                                        formSetValue("tipo_destino", null);
                                        setDetallesSalida([]);
                                        setDetallesSobrante([]);
                                    };

                                    if (
                                        detallesSalida.length > 0 ||
                                        detallesSobrante.length > 0
                                    ) {
                                        MostrarMensajeCambiarTipoSalida(
                                            aplicarCambio,
                                        );
                                    } else {
                                        aplicarCambio();
                                    }
                                }}
                            />
                        )}
                    />
                    {formErrors.tipo_salida && (
                        <small className="text-danger">
                            {formErrors.tipo_salida.message}
                        </small>
                    )}
                </div>

                <div className="formulario-field" style={{ minWidth: "100px" }}>
                    <label className="text-nowrap">Fecha</label>
                    <input
                        type="text"
                        className="form-control"
                        value={fechaHoraBodega.format("DD/MM/YYYY")}
                        disabled
                    />
                    {formErrors.fecha && (
                        <small className="text-danger">
                            {formErrors.fecha.message}
                        </small>
                    )}
                </div>

                <div className="formulario-field" style={{ minWidth: "100px" }}>
                    <label className="text-nowrap">Turno</label>
                    <input
                        type="text"
                        className="form-control"
                        value={
                            fechaHoraBodega.hour() < 18 ? "Diurno" : "Nocturno"
                        }
                        disabled
                    />
                    {formErrors.turno && (
                        <small className="text-danger">
                            {formErrors.turno.message}
                        </small>
                    )}
                </div>

                <div className="formulario-field" style={{ minWidth: "100px" }}>
                    <label className="text-nowrap">Supervisor</label>
                    <input
                        type="text"
                        className="form-control"
                        value={nombreUsuario}
                        disabled
                    />
                </div>
            </div>
            <div className="formulario-fields-row">
                <div className="formulario-field" style={{ minWidth: "150px" }}>
                    <label className="text-nowrap">Tipo de destino</label>
                    <Controller
                        name="tipo_destino"
                        control={formControl}
                        rules={{
                            required: "Este campo es obligatorio",
                        }}
                        render={({ field }) => (
                            <Select
                                {...field}
                                className="react-select-container"
                                backspaceRemovesValue={false}
                                isSearchable
                                options={opcionesDestinoFiltradas}
                                placeholder={
                                    !tipoSalidaSeleccionada
                                        ? "Seleccionar salida"
                                        : "Seleccionar"
                                }
                                isDisabled={!tipoSalidaSeleccionada}
                                onChange={(selectedOption) => {
                                    const destinoActual = field.value;

                                    // Si realmente no cambió, no hacer nada
                                    if (
                                        (destinoActual &&
                                            destinoActual.value) ===
                                        (selectedOption && selectedOption.value)
                                    ) {
                                        return;
                                    }

                                    const aplicarCambio = () => {
                                        field.onChange(selectedOption);
                                        setDetallesSalida([]);
                                        setDetallesSobrante([]);
                                    };

                                    if (
                                        detallesSalida.length > 0 ||
                                        detallesSobrante.length > 0
                                    ) {
                                        MostrarMensajeCambiarTipoDestino(
                                            aplicarCambio,
                                        );
                                    } else {
                                        aplicarCambio();
                                    }
                                }}
                            />
                        )}
                    />
                    {formErrors.tipo_destino && (
                        <small className="text-danger">
                            {formErrors.tipo_destino.message}
                        </small>
                    )}
                </div>

                <div
                    className="formulario-field"
                    style={{ minWidth: "100px", flex: 3.1 }}
                >
                    <label className="text-nowrap">Observaciones</label>
                    <input
                        type="text"
                        className="form-control"
                        {...formRegister("observaciones", {})}
                    />
                </div>
            </div>
            <AvisoPalletsIngresadosDespues pallets={palletsOcultos} />
            <DetallesSalidaList
                detallesSalida={detallesSalida}
                setDetallesSalida={setDetallesSalida}
                tipoDestinoSeleccionado={
                    tipoDestinoSeleccionado && tipoDestinoSeleccionado.value
                }
                almacenesReprocesoDisponibles={almacenesReprocesoDisponibles}
            />
            <DetallesSalidaSobranteList
                detallesSobrante={detallesSobrante}
                setDetallesSobrante={setDetallesSobrante}
                tipoDestinoSeleccionado={
                    tipoDestinoSeleccionado && tipoDestinoSeleccionado.value
                }
                almacenesReprocesoDisponibles={almacenesReprocesoDisponibles}
            />
            <div className="d-flex justify-content-center mt-5 gap-1rem">
                <button className="btn btn-outline-dark" onClick={regresar}>
                    Regresar
                </button>
                <button className="btn btn-primary" onClick={FormSubmit}>
                    Guardar
                </button>
            </div>
        </LoadMask>
    );
};
